module.exports = __webpack_public_path__ + "static/IMG_2615-540b7b666a17b2c09e03e6c2b4533852.jpg";